import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import FundingsourceFormData from "./FundingsourceFormData.js";


const EditFundingsource = (props) => {
  //get DispensingLanguage
  const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
  const lan = localStorage.getItem('LangCode');
  const menukey = "funding-source-entry";
  const UserInfo = sessionStorage.getItem("User_info")? JSON.parse(sessionStorage.getItem("User_info")): 0;  
  const UserName = UserInfo==0?'': UserInfo[0].id;

  


  const [formData, setFormData] = useState({
    FundingSourceName: "",
    FundingSourceDesc: ""
  });
  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  // console.log('get item',id);
  const queryClient = useQueryClient();

  const { data } = useQuery(
   
    ["FundingsourceServer", id],
    () =>
      api.getFundingsource(id).then((res) => {
         console.log(res.data);
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate } = useMutation(api.updatefundingsource, {
    onSuccess: (data) => {
      if (data.data.status == 200) {

        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
		
        queryClient.getQueriesData("FundingsourceServer");
        props.history.push("/funding-source-entry");
            
        }else{   
          props.openNoticeModal({
            isOpen: true,
            msg: data.data.message,
            msgtype: data.data.success,
          });
		
        }
    
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      FundingSourceName: "",
      FundingSourceDesc: ""
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["FundingSourceName"];
    let errorData = {};
    let isValid = true;
    console.log(validateFields);
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !'];
        isValid = false;
       
      }

    });
    setErrorObject(errorData);
    return isValid;
  };


  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      mutate(fDtat);
      //mutate(formData);
     
    }
  };

  return (
    <>
      <FundingsourceFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        {...props}
      />
    </>
  );
};

export default EditFundingsource;
